export default __webpack_public_path__ + "static/media/checkout.a4aa0466.png";